import { IKnmErknmFormEvent } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';
import { IKnmErknmFormEventSelectOption } from '../../../KnmErknmPackage/ErknmInfoModule/interfaces/IKnmErknmFormEventSelectOption';

export function createKnmErknmFormEventSelectOption(
  event: IKnmErknmFormEvent,
  index: number,
): IKnmErknmFormEventSelectOption {
  const eventType = event.type?.title || '';

  return {
    ...event,
    id: event.listId,
    label: `Действие № ${index + 1}: ${eventType}`,
    value: event.listId,
  };
}
